import { forwardRef } from '@chakra-ui/react';

import Text, { type TextProps } from '../../../Text';

const Title = forwardRef<TextProps, 'p'>((props, ref) => (
  <Text fontWeight="weight-500" ref={ref} variant="primary" {...props} />
));

export default Title;
